"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FOOD_RATION_PAGE_TYPE = exports.UNIVERSITY_PAGE_TYPE = exports.BANKRUPTCY_PAGE_TYPE = exports.MARKETPLACE_PAGE_TYPE = exports.LEASING_PAGE_TYPE = exports.NPF_PAGE_TYPE = exports.BOOKMAKER_PAGE_TYPE = exports.BROKER_PAGE_TYPE = exports.SCHOOL_PAGE_TYPE = exports.MFO_PAGE_TYPE = exports.INSURANCE_COMPANY_PAGE_TYPE = exports.BANKS_PAGE_TYPE = exports.PAGE_TYPE = void 0;
var PAGE_TYPE;
(function (PAGE_TYPE) {
    PAGE_TYPE["Bank"] = "bank";
    PAGE_TYPE["Banki"] = "banki";
    PAGE_TYPE["Banks"] = "banks";
    PAGE_TYPE["StrakhovajaKompanija"] = "strakhovaja-kompanija";
    PAGE_TYPE["StrakhovyeKompanii"] = "strakhovye-kompanii";
    PAGE_TYPE["InsuranceCompany"] = "insuranceCompany";
    PAGE_TYPE["Insurance"] = "insurance";
    PAGE_TYPE["Zaimy"] = "zaimy";
    PAGE_TYPE["MikrofinansovyeOrganizacii"] = "mikrofinansovye-organizacii";
    PAGE_TYPE["MikrofinansovajaOrganizacija"] = "mikrofinansovaja-organizacija";
    PAGE_TYPE["Mfi"] = "mfi";
    PAGE_TYPE["Mfo"] = "mfo";
    PAGE_TYPE["Shkoly"] = "shkoly";
    PAGE_TYPE["Shkola"] = "shkola";
    PAGE_TYPE["Kursy"] = "kursy";
    PAGE_TYPE["EducationalOrganization"] = "educationalOrganization";
    PAGE_TYPE["Broker"] = "broker";
    PAGE_TYPE["Brokery"] = "brokery";
    PAGE_TYPE["Bukmeker"] = "bukmeker";
    PAGE_TYPE["Bukmekery"] = "bukmekery";
    PAGE_TYPE["Bookmaker"] = "bookmaker";
    PAGE_TYPE["Npf"] = "npf";
    PAGE_TYPE["Leasing"] = "leasing";
    PAGE_TYPE["Marketplace"] = "marketplace";
    PAGE_TYPE["Bankruptcy"] = "bankruptcy";
    PAGE_TYPE["University"] = "university";
    PAGE_TYPE["Raciony"] = "raciony";
    PAGE_TYPE["RacionyKompanii"] = "raciony-kompanii";
    PAGE_TYPE["FoodRation"] = "foodRation";
})(PAGE_TYPE = exports.PAGE_TYPE || (exports.PAGE_TYPE = {}));
exports.BANKS_PAGE_TYPE = [PAGE_TYPE.Bank, PAGE_TYPE.Banki, PAGE_TYPE.Banks];
exports.INSURANCE_COMPANY_PAGE_TYPE = [
    PAGE_TYPE.StrakhovajaKompanija,
    PAGE_TYPE.StrakhovyeKompanii,
    PAGE_TYPE.InsuranceCompany,
    PAGE_TYPE.Insurance,
];
exports.MFO_PAGE_TYPE = [
    PAGE_TYPE.Mfi,
    PAGE_TYPE.Mfo,
    PAGE_TYPE.Zaimy,
    PAGE_TYPE.MikrofinansovajaOrganizacija,
    PAGE_TYPE.MikrofinansovyeOrganizacii,
];
exports.SCHOOL_PAGE_TYPE = [
    PAGE_TYPE.Shkoly,
    PAGE_TYPE.Shkola,
    PAGE_TYPE.EducationalOrganization,
    PAGE_TYPE.Kursy,
];
exports.BROKER_PAGE_TYPE = [PAGE_TYPE.Brokery, PAGE_TYPE.Broker];
exports.BOOKMAKER_PAGE_TYPE = [PAGE_TYPE.Bukmekery, PAGE_TYPE.Bukmeker, PAGE_TYPE.Bookmaker];
exports.NPF_PAGE_TYPE = [PAGE_TYPE.Npf];
exports.LEASING_PAGE_TYPE = [PAGE_TYPE.Leasing];
exports.MARKETPLACE_PAGE_TYPE = [PAGE_TYPE.Marketplace];
exports.BANKRUPTCY_PAGE_TYPE = [PAGE_TYPE.Bankruptcy];
exports.UNIVERSITY_PAGE_TYPE = [PAGE_TYPE.University];
exports.FOOD_RATION_PAGE_TYPE = [PAGE_TYPE.Raciony, PAGE_TYPE.FoodRation, PAGE_TYPE.RacionyKompanii];
